import "../Home.css";
import "./index.css"
import React, {Component} from "react";
import {request} from "../../../api-client";
import localization from "../../../config/localization";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";
import {FormControl, Grid, IconButton, InputLabel, MenuItem, Select} from "@material-ui/core";
import 'react-input-range/lib/css/index.css'
import qs from "qs";
import browserHistory from "../../../utils/browserHistory";
import {homePathGenerator, setPageTitle} from "../../../api-client/core/authentication/utils";
import BloomSpinner from "../../../assets/img/bloom_spinner_grey.gif";
import EventManager, {events} from "../../../utils/EventManager";
import ChipBar from "../../../components/Letflow/ChipBar";
import ContentCreatorItem from "../../../components/Letflow/ContentCreatorItem";
import HomeSearchInput from "../../../components/Letflow/HomeSearchInput";
import InfiniteScroll from "react-infinite-scroll-component";
import ContentCreationPlayer from "../../../components/Letflow/ContentCreationPlayer";
import GlobalAddToPlaylistDialog from "../../../components/Letflow/AddToPlaylistDialog/GlobalAddToPlaylistDialog";
import Link from "react-router-dom/Link";
import { Edit } from "@material-ui/icons";
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";

class SmartSearchContentCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagGroups: [],
      searchResultsTags: [],
      searchResultsTitle: [],
      showTagSelection: true,
      showTagDialog: false,
      searchGroup: "contentCreation",
      type: '',
      contentCreatorId: '',
      selectedContentCreators: [],
      selectedCountry: '',
      showTags: false,
      pageReady: false,
      favorites: [],
      contentCreators: [],
      availableContentCreatorTypes: [],
      selectedCategories: [],
      selectedGlobalTags: [],
      lastPage: 0,
      currentPage: 0,
      search: "",
      showContentCreationDialog: false,
      currentContentCreatorType: null,
      showShareDialog: false,
      shareLink: "",
      shareToken: "",
    }
  }

  componentDidMount = () => {
    document.getElementsByTagName('html')[0].scrollTop = 0
    this.requestHasQueryParams()
      .then(() => this.readQueryStringParams())
      // .then(() => this.requestContentCreatorTypes())
      .then(() => this.setState({showTags: true}))
      .then(() => {
        this.requestContentCreatorType().then(this.requestTagGroups)
        this.requestTracks()
      })
    setPageTitle(localization.get('title.smart_search'))

    EventManager.getInstance().subscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().subscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)

    let queryString = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
      depth: 2,
      plainObjects: true})

    if(queryString && queryString.contenido) {
      EventManager.getInstance().dispatch(events.OPEN_CONTENT_MODAL, {id: queryString.contenido.split("-")[0], dataType: "contentCreator", dataName: queryString.contenido.split("-")[1] || "contenido", onTagChange: this.handleNewSearch || false});
    }
  }

  componentWillUnmount = () => {
    EventManager.getInstance().unsubscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().unsubscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)
  }

  onFavorite = (creation) => {
    if(!creation.favorite) {
      this.addToFavorites(creation.id)
    } else  {
      this.removeFromFavorites(creation.id)
    }
  }

  renderShareDialog = () =>
    <ShareOnSocials
      show={this.state.showShareDialog}
      handleClose={() => this.setState({showShareDialog: false})}
      url={this.state.shareLink}
      darkMode
      shareToken={this.state.shareToken}
    />

  onShare = (creator) => request.contentCreator.share(creator.id)
    .then(response => this.setState({
      showShareDialog: true,
      shareLink: `${window.location.protocol}//${window.location.hostname}/public/content_creators/${response.code}`,
      shareToken: response.code
    }))

  addToFavorites = id => {
    this.setState(state => ({
      ...state,
      searchResultsTags: state.searchResultsTags.map(creation => {
        if (creation.id === id) {
          return ({...creation, favorite: true})
        }
        return creation
      })
    }))
    request.contentCreatorFavorite.add(id)
  }

  removeFromFavorites = id => {
    this.setState(state => ({
      ...state,
      searchResultsTags: state.searchResultsTags.map(creation => {
        if (creation.id === id) {
          return ({...creation, favorite: false})
        }
        return creation
      })
    }))

    request.contentCreatorFavorite.remove(id)
  }


  requestHasQueryParams = () =>
    new Promise(resolve => {
      let search = qs.parse(this.props.location.search.slice(1))
      let {tags_ids, not_tags_ids, type} = search
      this.setState({type})
      if (tags_ids || not_tags_ids ) {
        this.setState({showTagSelection: false})
      }
      resolve()
    })

  readQueryStringParams = () =>
    new Promise(resolve => {
      let search = qs.parse(this.props.location.search.slice(1))
      let {tags_ids, q, type} = search

      if (!q) q="";
        this.setState({
          search: q,
          type: type
        })

      resolve()
    })

  writeQueryStringParams = () => {
    let {type, search,  selectedGlobalTags} = this.state
    browserHistory.push({
      pathname: window.location.pathname,
      search: qs.stringify({
        type: type,
        tags_ids: selectedGlobalTags.filter(tag => tag.selectedTag !== "0").map(tag => tag.selectedTag).join(','),
        q: search,
      })
    })
  }

  requestTagGroups = () =>
    request.tagGroup.getAll(
      {filterBy: [
          { column: 'type', filter: this.state.type },
          { column: "target_type", filter: "talent" },
          { column: "creation", filter: 0 },
          { column: 'target_brand', filter: this.state.currentContentCreatorType.brand},
    ]}, "include=tags")
      .then(tagGroups => {
        const selectedTags = tagGroups.map(tg => ({tagGroupId: tg.id, selectedTag: "0"}))

        this.setState({ tagGroups: tagGroups, selectedGlobalTags: selectedTags })
      })

  requestContentCreatorType = () =>
    request.contentCreatorType.getAll({filterBy: [{column: 'slug', filter: this.state.type}]})
      .then(contentCreatorTypes => this.setState({ currentContentCreatorType: contentCreatorTypes[0] }))

  requestContentCreatorTypes = () => {
    return request.contentCreatorType.getAll({filterBy: [
        {column: "type", filter: "talent"},
        //{ column: 'smart_search', filter: true}
      ]})
      .then(availableContentCreatorTypes => {
        this.setState({ availableContentCreatorTypes: availableContentCreatorTypes })
      })
  }

  disableAllTagsForRequest = () => {
    this.setState(state => ({
      ...state,
      tagGroups: state.tagGroups.map(tgs => ({
        ...tgs,
        tags: tgs.tags.map(tag => ({
          ...tag,
          state: 'disable'
        }))
      }))
    }))
  }

  requestTracks =
    ({
       type = this.state.type,
       page = 0,
       clearResults = true,
       search = this.state.search,
     } = {}) => {
    return request.contentCreator.getAllWithTags(
      type,
      this.state.selectedGlobalTags.filter(tag => tag.selectedTag !== "0").map(tag => tag.selectedTag),
      null,
      search,
      {perPage: 24, page: page}
    ).then(searchResults => {
      let results = searchResults.data

      if(!clearResults) {
        results = this.state.searchResultsTags.concat(searchResults.data)
      }

      this.setState({
        searchResultsTags: results.filter(c => c.name),
        showTagSelection: false,
        lastPage: searchResults.meta.last_page,
        currentPage: searchResults.meta.current_page,
        total: searchResults.meta.total,
      })
    })
      .then(() => this.setState({pageReady: true}))
      .catch(e=> {
        console.log(e)
        GlobalSnackbar.show({
          message: 'smart_search_request_failed',
          type: GlobalSnackbarTypes.ERROR,
        })
      })
  }

  renderGlobalSelectors = () => {
    return (
      <div className="smart-search-type-selectors" style={{width: "100%", position: "relative", float: "left",  margin: "70px 0 20px 0", flexWrap: "wrap"}}>
        {this.state.tagGroups.length > 0 && this.state.tagGroups.filter(tg => tg.is_global).slice(0, 4).map((tagGroup, key) =>
          <FormControl className={key%2 == 0 ? "smart-search-selector-control first" : "smart-search-selector-control"} style={{marginBottom: 10, position: "relative", float: "left"}}>
            <InputLabel className="smart-search-selector-label" style={{fontSize: 19, textTransform: "uppercase", color: "black", position: "absolute", fontWeight: "bold"}}>{tagGroup.name}</InputLabel>
            <Select
              disableUnderline
              value={this.state.selectedGlobalTags.find(selectedTag => selectedTag.tagGroupId === tagGroup.id) ? this.state.selectedGlobalTags.find(selectedTag => selectedTag.tagGroupId === tagGroup.id).selectedTag : "0"}
              style={{border: "1px solid #ccc", textAlign: "left", padding: "0 5%", color: "#6a6a6a", background: "white"}}
              onChange={(e) => {
                let newSelectedGlobalTags = this.state.selectedGlobalTags.filter(selectedTag => selectedTag.tagGroupId !== tagGroup.id)
                newSelectedGlobalTags.push({tagGroupId: tagGroup.id, selectedTag: e.target.value})
                this.setState({selectedGlobalTags: newSelectedGlobalTags}, () => this.requestTracks().then(() => this.writeQueryStringParams()))
              }}
            >
              <MenuItem value="0" style={{color: "#6a6a6a"}}>{localization.get("all")}</MenuItem>
              {tagGroup.tags.map(tag =>
                <MenuItem value={tag.id} style={{color: "#6a6a6a"}}>{tag.name}</MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </div>
    )
  }

  renderTypeSelectors = () => {
    let showEditIcon = window.innerWidth <= 850;
    return (
      <div className="smart-search-type-selectors" style={{width: "100%", position: "relative", float: "left",  margin: "0 0 20px 0", flexWrap: "wrap"}}>
        <div className={this.state.tagGroups.length > 0 && this.state.tagGroups.filter(tg => !tg.is_global).length > 1 ? "smart-search-type-selectors-long-background" : "smart-search-type-selectors-background"}/>
        <div className="smart-search-selector-control first" style={{position: "relative", float: "left", paddingTop: 24, marginBottom: 10}}>
          <p style={{textAlign: "left", display: 'flex', alignItems: 'center'}}>
            <InputLabel style={{fontSize: 16, textTransform: "uppercase", color: "black", position: "relative", fontWeight: "bold", letterSpacing: -.5, float: "left", maxWidth: showEditIcon ? "calc(100% - 30px)" : "calc(100% - 61px)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{this.state.currentContentCreatorType.name}</InputLabel>
            {showEditIcon ? 
              <Link className="smart-search-type-edit" style={{color: "black"}} to={homePathGenerator('busqueda-inteligente')} ><IconButton style={{color: 'black', width: '30px', height: '20px'}}><Edit style={{fontSize: 18}}/></IconButton></Link>
            :
            <>
              <span style={{fontSize: 22, textTransform: "uppercase", color: "black", position: "relative",float: "left", marginTop: -1, marginLeft: 10}}>|</span>
              <Link style={{fontSize: 12, marginLeft: 5, textTransform: "capitalize", color: "black", position: "relative"}} to={homePathGenerator('busqueda-inteligente')} >{localization.get('home.smart_search.change_type')}</Link>
            </>
            }
          </p>
        </div>
        {this.state.tagGroups.length > 0 && this.state.tagGroups.filter(tg => !tg.is_global).slice(0, 3).map((tagGroup, key) =>
          <FormControl className={key == 1 ? "smart-search-selector-control first" : "smart-search-selector-control"} style={{position: "relative", float: "left", marginBottom: 10}}>
            <InputLabel className="smart-search-selector-label" style={{fontSize: 19, textTransform: "uppercase", color: "black", position: "absolute", fontWeight: "bold"}}>{tagGroup.name}</InputLabel>
            <Select
              disableUnderline
              value={this.state.selectedGlobalTags.find(selectedTag => selectedTag.tagGroupId === tagGroup.id) ? this.state.selectedGlobalTags.find(selectedTag => selectedTag.tagGroupId === tagGroup.id).selectedTag : "0"}
              style={{border: "1px solid #ccc", textAlign: "left", padding: "0 5%", color: "#6a6a6a", background: "white"}}
              onChange={(e) => {
                let newSelectedGlobalTags = this.state.selectedGlobalTags.filter(selectedTag => selectedTag.tagGroupId !== tagGroup.id)
                newSelectedGlobalTags.push({tagGroupId: tagGroup.id, selectedTag: e.target.value})
                this.setState({selectedGlobalTags: newSelectedGlobalTags}, () => this.requestTracks().then(() => this.writeQueryStringParams()))
              }}
            >
              <MenuItem value="0" style={{color: "#6a6a6a"}}>{localization.get("all")}</MenuItem>
              {tagGroup.tags.map(tag =>
                <MenuItem value={tag.id} style={{color: "#6a6a6a"}}>{tag.name}</MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </div>
    )
  }

  onCategoriesSelectedChange = categoryId => {
    let currentCategories = this.state.selectedCategories
    if (currentCategories.includes(categoryId)) {
      return this.setState({selectedCategories: currentCategories.filter(cat => cat !== categoryId)}, () => {
        this.writeQueryStringParams()
        this.requestTracks()
      })
    }

    currentCategories.push(categoryId)
    return this.setState({selectedCategories: currentCategories}, () => {
      this.writeQueryStringParams()
      this.requestTracks()
    })
  }

  handleSearchInputKeyPress = () => {
    this.interval && clearInterval(this.interval)
    this.interval = setTimeout(() => {
      if(this.state.search.length > 2 || this.state.search.length === 0) {
        this.writeQueryStringParams();
        this.requestTracks();
      }
    }, 200)
  };

  render = () => {
    if (!this.state.pageReady || !this.state.currentContentCreatorType){
      return (
        <div style={{ height: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}>
          <img style={{width: 100, height: 100, marginTop: "calc(43vh - 30px)"}} src={BloomSpinner} alt="Loading logo"/>
        </div>
      )
    } else {
      return (
        <div className="smart-search-category-container">
          <ContentCreationPlayer
            show={this.state.showContentCreationDialog}
            currentContentCreation={this.state.currentPlayingContent}
            handleClose={() => this.setState({showContentCreationDialog: false,currentPlayingContent: {}})}
          />
          <HomeSearchInput
            value={this.state.search}
            placeholder={"searchbar.smart_search"}
            onSearch={value => this.setState({search: value}, this.handleSearchInputKeyPress)}
          />
          {this.renderShareDialog()}
          {this.renderGlobalSelectors()}
          {this.renderTypeSelectors()}
          {/*<ChipBar onClick={categoryId => this.onCategoriesSelectedChange(categoryId)} chips={this.state.availableContentCreatorTypes} selectedChips={this.state.selectedCategories}/>*/}
          {this.state.searchResultsTags.length > 0 ?
            <InfiniteScroll
              style={{display: "flex", flexWrap: "wrap", position: "relative", float: "left", width: "100%"}}
              dataLength={this.state.searchResultsTags.length}
              next={() => this.requestTracks({page: this.state.currentPage++, clearResults: false})}
              hasMore={this.state.currentPage < this.state.lastPage}
              loader={<div
                style={{height: "70px", paddingTop: 20, width: "100%", display: "flex", justifyContent: "center", alignContent: "center"}}
              >
                <img style={{width: 50, height: 50}} src={BloomSpinner} alt="Loading logo"/>
              </div>}
            >
              <Grid  container fullWidth>
                {this.state.searchResultsTags.length > 0 && this.state.searchResultsTags.map((creator, key) =>
                  <Grid key={key} xs={12} sm={6} md={3} lg={2} xl={2} item style={{padding: 10, width: "100%"}}>
                    <ContentCreatorItem
                      contentCreator={creator}
                      onFavorite={() => this.onFavorite(creator)}
                      onShare={() => this.onShare(creator)}
                      onAddToPlaylist={() =>
                        GlobalAddToPlaylistDialog.show({
                          type: "contentCreator",
                          selectedContent: creator,
                        })}
                    />
                  </Grid>
                )}
              </Grid>
            </InfiniteScroll>
            :
            <div style={{position: "relative", float: "left", width: "100%", padding: "100px 0"}}>
              <p style={{color: "#ccc", fontSize: 32, fontWeight: "bold", textAlign: "center"}}>{localization.get('smart_search.no_result')}</p>
            </div>
          }

        </div>
      )
    }
  }
}

export default SmartSearchContentCreator;